var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title",class:{'is-border':_vm.isBorder}},[_c('h2',{staticClass:"title-inner"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@15.9.1@vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/_vue-loader@15.9.1@vue-loader/lib??vue-loader-options!./src/components/title.vue?vue&type=template&id=d88f6372&scoped=true&
// module id = 50
// module chunks = 0